import { StdInventoryIndicesAggregateBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { StdIndexInfo } from '@/coreDomainsModule/entities/inventory';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class PutStdInventoryIndicesAdapter {
  /**
   * フロント側の型に変換を行う
   * @param stdInventoryIndicesInfo - 標準在庫指数情報
   */
  public static adapt = (stdInventoryIndicesInfo: StdIndexInfo): StdInventoryIndicesAggregateBusinessIdPutRequest => {
    return {
      putStdInventoryIndicesRequestInfo: {
        stdInventoryIndicesMin: stdInventoryIndicesInfo.min,
        stdInventoryIndicesMax: stdInventoryIndicesInfo.max,
        stdInventoryIndicesUnit: stdInventoryIndicesInfo.unit,
      },
    };
  };
}
